import { PRODUCT_TAG } from 'constants/Tags';
import TagTypeProps from 'constants/TagTypeProps';
import { useAuth } from 'context/Auth';
import { REGION_MB, TAG_HANG_DAT_TRUOC, TAG_NEW } from 'sysconfig';
import DateTimeUtils from 'utils/DateTimeUtils';
import { useStore } from 'zustand-lib/storeGlobal';
import ProductTag from '../ProductTag';

export const tagTypePropsArr = [
  'OUT_OF_STOCK',
  'SUSPENDED',
  'GIFT',
  'FLASH_SALE',
  'MEGA_DAY',
  'DEAL',
  TAG_HANG_DAT_TRUOC,
  'FV2U',
  PRODUCT_TAG.HANG_DIEM,
  PRODUCT_TAG.HANG_HANG,
  PRODUCT_TAG.HOADONNHANH,
  PRODUCT_TAG.BANCHAY,
  'BAN_CHAY',
  '84AB',
  '3ABC',
];
const tagIconArr = ['GIAONHANH', 'W80T', 'BAN_CHAY', 'BANCHAY', 'HOADONNHANH'];
const tagNoDisplayArr = [TAG_NEW];

export const getTagName = (item, getStyleBySlugOfTag) => {
  if (item === 'NEAR_EXPIRATION') {
    return 'Cận date';
  }
  if (tagNoDisplayArr?.indexOf(item) >= 0) {
    return null;
  }
  const tagInfo = TagTypeProps[item];
  if (tagInfo?.name) {
    return tagInfo.name;
  }
  return getStyleBySlugOfTag(item)?.name || '';
};

// notes
// cận date chưa làm ,  nếu có status cận date
// khuyến mãi , nếu có deal tự thêm mã giảm giá vào tag
// nên chuyển về 1 cái , làm sau
const TagType = ({ item, exp, isTooltip = false, isDisplayFull = false, link, isLinkTagDeal, isProductDetailNew = false, isProductDetailPage = false, isHangDiemStore = false, iconHangDiem }) => {
  const getStyleBySlugOfTag = useStore((state) => state.getStyleBySlugOfTag);
  const { customerInfo } = useAuth();

  let props = {};
  if (item === TAG_HANG_DAT_TRUOC && REGION_MB.indexOf(`${customerInfo?.provinceCode}`) < 0) {
    return null;
  }
  if (item === 'NEAR_EXPIRATION') {
    const date = DateTimeUtils.getFormattedDate(new Date(exp), 'DD-MM-YYYY');
    const { name, code, textColor, backgroundColor, url } = TagTypeProps.NEAR_EXPIRATION;
    props = {
      name: `${name} ${isProductDetailNew ? '' : date}`,
      date,
      code,
      textColor,
      backgroundColor,
      url,
    };
  } else if (!isDisplayFull && tagNoDisplayArr?.indexOf(item) >= 0) {
    return null;
  } else {
    // nếu ko có option nào thì lấy theo API trả về
    let tagInfo = TagTypeProps[item];
    // TODO: property of tag "HANG DIEM" will take from internal tag/edit
    if (isHangDiemStore && tagInfo?.code === "2ABC") {
      if (isProductDetailPage) {
        // keep the code, change another one
        tagInfo = {
          ...iconHangDiem,
          code: "2ABC",
          hangDiemLink: link
        };
      } else {
        // keep current tagInfo, change the name
        tagInfo = {
          ...tagInfo,
          name: iconHangDiem?.name,
          hangDiemLink: link,
        };
      }
    }
    props = tagInfo ? { ...tagInfo, isTooltip, isProductDetailPage, isHangDiemStore } : getStyleBySlugOfTag(item);
    if (props && !props?.name) {
      props.name = getStyleBySlugOfTag(item)?.name || '';
    }
    if (props && !props?.slug) {
      props.slug = getStyleBySlugOfTag(item)?.slug || '';
    }
    if (!props) {
      return null;
    }
    if (tagIconArr?.indexOf(item) >= 0) {
      props = { ...props, isTooltip };
    }
  }
  return <ProductTag link={link} isLinkTagDeal={isLinkTagDeal} {...props} />;
};

export default TagType;
